module.exports = __webpack_public_path__ + "assets/final-type-4.png";